import { gql } from '@apollo/client';

export const SUBSCRIBE_PLAN_MUTATION = gql`
  mutation SubscribePlan($input: SubscribePlanInput!) {
    subscribePlan(input: $input) {
      planId
      status
      expiresAt
      startedAt
      isActive
      clientSecret
      requiresAction
      pendingActionType
    }
  }
`;

// Note: This mutation is now merged into SUBSCRIBE_PLAN_MUTATION
// The new SubscribePlanInput includes optional paymentMethodId (merged into SUBSCRIBE_PLAN_MUTATION)

export const GET_MY_PAYMENT_METHODS_QUERY = gql`
  query GetMyPaymentMethods {
    myPaymentMethods {
      id
      type
      customerId
      isDefault
      card {
        brand
        last4
        expMonth
        expYear
      }
      satispay {
        placeholder
      }
    }
  }
`;

export const ADD_PAYMENT_METHOD_MUTATION = gql`
  mutation AddPaymentMethod($input: AddPaymentMethodInput!) {
    addPaymentMethod(input: $input)
  }
`;

export const CREATE_PAYMENT_METHOD_SETUP_INTENT_MUTATION = gql`
  mutation CreatePaymentMethodSetupIntent($input: CreatePaymentMethodSetupIntentInput!) {
    createPaymentMethodSetupIntent(input: $input) {
      clientSecret
    }
  }
`;

export const REMOVE_PAYMENT_METHOD_MUTATION = gql`
  mutation RemovePaymentMethod($input: RemovePaymentMethodInput!) {
    removePaymentMethod(input: $input)
  }
`;

export const SET_DEFAULT_PAYMENT_METHOD_MUTATION = gql`
  mutation SetDefaultPaymentMethod($input: SetDefaultPaymentMethodInput!) {
    setDefaultPaymentMethod(input: $input)
  }
`;

// New subscription queries for the refactored backend
export const GET_MY_SUBSCRIPTION_QUERY = gql`
  query GetMySubscription {
    mySubscription {
      planId
      plan {
        id
        name
        description
        planType
        amount
        currency
        features
        interval
      }
      status
      expiresAt
      startedAt
      isActive
      isPremium
      clientSecret
      requiresAction
      pendingActionType
    }
  }
`;

export const GET_MY_SUBSCRIPTION_PERMISSIONS_QUERY = gql`
  query GetMySubscriptionPermissions {
    mySubscriptionPermissions {
      canCreatePaidEvents
      canSeeEventParticipants
      canBringGuests
      canSendAutomaticEmails
      maxEventsPerMonth
      adsHidden
      maxGuests
    }
  }
`;

export const GET_AVAILABLE_PLANS_QUERY = gql`
  query AvailablePlans {
    availablePlans {
      id
      name
      description
      interval
      amount
      currency
      features
      planType
      permissions {
        canCreatePaidEvents
        canSeeEventParticipants
        canBringGuests
        canSendAutomaticEmails
        maxEventsPerMonth
        adsHidden
        maxGuests
      }
      metadata {
        key
        value
      }
    }
  }
`;

// New query for subscription plan change preview with proration calculation
// Note: plan-change previews were removed in favor of cancellation-only previews.

export const CANCEL_SUBSCRIPTION_MUTATION = gql`
  mutation CancelSubscription($reason: String) {
    cancelSubscription(reason: $reason) {
      subscription {
        planId
        status
        expiresAt
        startedAt
        isActive
        isPremium
      }
    }
  }
`;

export const REACTIVATE_SUBSCRIPTION_MUTATION = gql`
  mutation ReactivateSubscription {
    reactivateSubscription {
      planId
      status
      expiresAt
      startedAt
      isActive
      isPremium
    }
  }
`;

export const RETRY_SUBSCRIPTION_PAYMENT_MUTATION = gql`
  mutation RetrySubscriptionPayment {
    retrySubscriptionPayment {
      planId
      status
      expiresAt
      startedAt
      isActive
      isPremium
      clientSecret
      requiresAction
      pendingActionType
    }
  }
`;
